import { StyleSheet } from 'react-native';

import type { useTheme } from './theme';

/** Style sheet for <FocusPanel>. Extracted from FocusPanel.tsx (SP-FOCUSPANEL,
 *  2026-07-27) to get that file under the 500-line cap; the body below is the
 *  former private makeStyles, moved verbatim and only widened to `export`. */
export function makeStyles(theme: ReturnType<typeof useTheme>) {
  const { palette: p, spacing: s, radius: r, typography: ty } = theme;
  return StyleSheet.create({
    panel: {
      backgroundColor: p.surface,
      borderColor: p.border,
      borderWidth: 1,
      borderRadius: r.r3,
      padding: s.s4,
      gap: s.s3,
    },
    // The editing block (LG-29) is now ONE flex child of the panel, so it carries
    // the same s3 gap the panel spaces its children with — otherwise the rows it
    // wraps would collapse together. Spacing is identical to before the wrap.
    editBlock: { gap: s.s3 },
    // The 🔥 Burn+ selector bar, sitting directly under the qualifier row.
    // SetTypeChipBar renders a bare chip fragment + a flex spacer that pushes ×
    // to the right, so it needs a row container (matches the card logger).
    setTypeBarRow: { flexDirection: 'row', alignItems: 'center', gap: s.s2 },
    // base + full-width 2-line wrap: the icons left the title row (AP-0g), so
    // the name now owns its line and long DE/RU names wrap instead of
    // truncating against a cluster.
    title: {
      color: p.ink,
      fontSize: ty.sizes.base,
      fontWeight: '700',
    },
    allDone: {
      color: p.ink3,
      fontSize: ty.sizes.sm,
    },
  });
}
